import { useQuery } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

export function useChannelBrandQuery() {
  const { api, isAuthenticated, sponsorId } = useAuth()

  return useQuery({
    queryFn: async () => {
      const response = await api.getCurrentChannelBrand()
      if (response.kind !== "ok") {
        throw new Error(`Failed to fetch channel brand: ${response.kind}`)
      }
      return response.data
    },
    queryKey: ["channel", "brand", sponsorId],
    enabled: !!api && isAuthenticated && !!sponsorId && sponsorId !== "unknown-sponsor",
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
